export default {
    data() {
        return {
            generos: []
        }
    },
    methods: {
        async getGeneros() {
            this.$store.dispatch(this.config.getVuexAlias('select.generos')).then(res => {
                this.generos = res.data.data;
            });
        },
    }
}